import React from "react";
import {useTranslation} from "react-i18next";
import CssBaseline from "@mui/material/CssBaseline";
import MainLayout from "../../components/layout/MainLayout";
import HelpAndSupport from "../../components/help-and-support";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";

const Index = () => {
    const {t} = useTranslation();
    const { configData, landingPageData, loading } = useConfigData();

    if (loading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                fontSize: '18px'
            }}>
                Loading...
            </div>
        );
    }

    
    

    

    return (
        <>
            <CssBaseline/>
            <SEO
                title={configData ? `Help and support` : "Loading..."}
                image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
                businessName={configData?.business_name}
            />

            <MainLayout configData={configData} landingPageData={landingPageData}>
                <HelpAndSupport configData={configData} t={t}/>
            </MainLayout>
        </>
    );
};

export default Index;
